import { FP, nanoid } from "../deps"

const storageKey = "sa_anon_id"

function getFromStorage(key: string): FP.io.IO<FP.option.Option<string>> {
  return () =>
    FP.option.fromNullable(
      window.localStorage &&
        window.localStorage.getItem &&
        window.localStorage.getItem(key)
    )
}

function putInStorage(key: string, value: string): FP.io.IO<string> {
  return () => {
    window.localStorage &&
      window.localStorage.setItem &&
      window.localStorage.setItem(key, value)
    return value
  }
}

let idCache: FP.option.Option<string> = FP.option.none

type IOOption<A> = FP.io.IO<FP.option.Option<A>>
const ioOptionAlt: <A>(
  that: FP.function.Lazy<IOOption<A>>
) => (fa: IOOption<A>) => IOOption<A> = (that) =>
  FP.io.chain(FP.option.fold(that, FP.function.flow(FP.option.of, FP.io.of)))

export const getAnonId: FP.io.IO<string> = FP.function.pipe(
  () => idCache,
  ioOptionAlt(() => getFromStorage(storageKey)),

  FP.io.chain(
    FP.option.fold(
      FP.function.flow(
        (): FP.io.IO<string> => () => `anon_${nanoid()}`,
        FP.io.chainFirst((id) => () => (idCache = FP.option.some(id))),
        FP.io.chainFirst((id) => putInStorage(storageKey, id))
      ),
      FP.io.of
    )
  )
)
